import React, { useState } from "react";
import axios from "axios";
import { getCookie } from '../../Utils/cookies';

const ServicePersonRegistration = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    password: "",
    longitude: "",
    latitude: "",
    block: "",
    district: "",
    state: "",
  });

  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const empData = getCookie('empData') ? JSON.parse(getCookie('empData')) : {};

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, contact, password, longitude, latitude, block, district, state } =
      formData;

    const createdAt = new Date().toISOString();

    if (!name || !email || !contact || !password) {
      alert("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`https://api.inventory.galosolar.com/warehouse-admin/service-person-signup`, 
      // await axios.post(`https://api.inventory.umancrm.in/warehouse-admin/service-person-signup`, 
        {
        name,
        email,
        contact,
        password,
        longitude,
        latitude,
        block,
        district,
        state,
        createdAt,
        createdBy: empData?._id,
      });

      alert("Registration Successful");

      setFormData({
        name: "",
        email: "",
        contact: "",
        password: "",
        longitude: "",
        latitude: "",
        block: "",
        district: "",
        state: "",
      });

    } catch (error) {
      alert(error.response?.data?.message || "Registration Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen px-4 py-10">

      <h2 className="text-2xl font-bold text-center mb-8">
        Service Person Registration
      </h2>

      <form
        onSubmit={handleSubmit}
        className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      >

        <div>
          <label className="text-sm font-medium">Name</label>
          <input
            type="text"
            placeholder="Name"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Contact</label>
          <input
            type="tel"
            maxLength={10}
            placeholder="Contact"
            value={formData.contact}
            onChange={(e) => handleChange("contact", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Email</label>
          <input
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div className="relative">
          <label className="text-sm font-medium">Password</label>
          <input
            type={passwordVisible ? "text" : "password"}
            placeholder="Password"
            value={formData.password}
            onChange={(e) => handleChange("password", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />

          <span
            className="absolute right-3 top-9 cursor-pointer"
            onClick={() => setPasswordVisible(!passwordVisible)}
          >
            {passwordVisible ? "🙈" : "👁"}
          </span>
        </div>

        <div>
          <label className="text-sm font-medium">Block</label>
          <input
            type="text"
            placeholder="Block"
            value={formData.block}
            onChange={(e) => handleChange("block", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div>
          <label className="text-sm font-medium">District</label>
          <input
            type="text"
            placeholder="District"
            value={formData.district}
            onChange={(e) => handleChange("district", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div>
          <label className="text-sm font-medium">State</label>
          <input
            type="text"
            placeholder="State"
            value={formData.state}
            onChange={(e) => handleChange("state", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Longitude</label>
          <input
            type="text"
            placeholder="Longitude"
            value={formData.longitude}
            onChange={(e) => handleChange("longitude", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Latitude</label>
          <input
            type="text"
            placeholder="Latitude"
            value={formData.latitude}
            onChange={(e) => handleChange("latitude", e.target.value)}
            className="w-full border border-gray-400 rounded-md p-2"
          />
        </div>

        <div className="col-span-full mt-4">
          <button
            type="submit"
            disabled={loading}
            className="w-full md:w-60 bg-black text-white py-3 rounded-md hover:bg-gray-900"
          >
            {loading ? "Registering..." : "Register"}
          </button>
        </div>

      </form>
    </div>
  );
};

export default ServicePersonRegistration;